import { Component } from '@angular/core';

import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
  //providers: [SharedService]
})
export class AppComponent{

  //Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;

  constructor() {}
}
